import axios from 'axios'
import store from '@/store'
import { Message } from 'element-ui'
import { getCookie } from '@/utils'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
    config => {
        config.headers['authorization'] = `Bearer ${store.state.token}`
        config.headers['X-CSRFToken'] = getCookie('csrftoken')
        config.withCredentials = true
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        // console.log('api return response', response);

        if (res.code && res.code !== 200) { // 请求失败
            console.log('api return error', res.message);
            // Message({ message: res.message || 'Error', type: 'error', duration: 5 * 1000 })
            if (res.code === 401) { // token错误
                store.commit('set_pageLoding', true); // 页面加载中
                store.commit('clear_all');
                alert(`${res.message},请重新登录`);
                window.location.href = '/'
            }
            if (res.code === 402) { // token过期
                store.commit('set_pageLoding', true); // 页面加载中
                store.commit('clear_all');
                window.location.href = '/';
                
            }
        }
        return res
    },
    error => {
        Message({ message: error.message, type: 'error', duration: 5 * 1000 })
        return Promise.reject(error)
    }
)

export default service
